import { handleRequest } from "../utilities/requestHandler";


// Order placement legitimately takes longer than a normal read (thousands of line items,
// ERP round trip). It gets its own generous timeout so the shared 30s default -- which exists
// to stop ordinary reads hanging forever -- can never turn a succeeding order into a false
// failure. Pair this with the client_request_id probe below rather than relying on it alone.
export const createOrder = (newCheckoutDetails) =>
    handleRequest("post", "/orders/create", newCheckoutDetails, { timeout: 180000 });

// After a timeout/network error we cannot know whether the order was created. Ask the server.
export const getOrderStatusByRequestId = (clientRequestId) =>
    handleRequest("post", "/orders/status-by-request", { client_request_id: clientRequestId });